/**
 * Combined team + backers section.
 */
export function AboutTeam() {
  return (
    <section className="w-full bg-withus-white px-6 pt-20 md:px-12 md:pt-28">
      <div className="mx-auto flex max-w-[1318px] flex-col items-center gap-16">
        <div className="flex max-w-[800px] flex-col items-center gap-6 text-center">
          <h2 className="withus-strong text-3xl leading-none text-withus-blue md:text-5xl">
            Our Team
          </h2>
          <p className="text-center text-lg md:text-xl">
            We're builders, operators, and owners across real estate, family business, technology,
            hospitality, and regulated financial markets &mdash; with diverse experience at places
            from Kickstarter to the U.S. Securities and Exchange Commission.
          </p>
          <p className="text-center text-lg md:text-xl">
            We're backed and advised by people who have built enduring companies, neighborhoods, and
            institutions — including Danny Meyer, Ken Chenault, Susan Sobbott of Small Business
            Saturday, Venus Williams, Will Smith, Julián Castro, and founders behind companies like
            DoorDash, Faire, Hyatt, Mercury, Plaid, Ramp, Reddit, Square, Trulia, and Yelp.
          </p>
        </div>
      </div>
    </section>
  );
}
